export default __webpack_public_path__ + "static/media/hero-contact.ccdd9ff7.jpg";